import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import './FormacionGratisDetalle.css';

const API     = 'https://centrocomunicar.com/api-comunicar/endpoints/formaciones_gratis.php';
const API_INS = 'https://centrocomunicar.com/api-comunicar/endpoints/formaciones_gratis.php';

/* ── Icons ── */
const IconPlay   = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M10 8l6 4-6 4V8z" fill="currentColor"/></svg>);
const IconCheck  = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconUsers  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClock  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconArrow  = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner= () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUser   = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/></svg>);
const IconMail   = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconExt    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M15 3h6v6M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const TIPO_LABEL = { video:'🎥 Video formativo', pdf:'📄 PDF descargable', clase:'🎓 Clase grabada', webinar:'📡 Webinar', recurso:'📦 Recurso' };
const PERFIL_OPTS = [
  { val:'profesional', label:'Profesional de salud' },
  { val:'familia',     label:'Familia / Cuidador'  },
  { val:'estudiante',  label:'Estudiante'           },
  { val:'otro',        label:'Otro'                 },
];

export default function FormacionGratisDetalle() {
  const { slug }  = useParams();
  const { estaLogueado, usuario, authHeader } = useAuthUser();

  const [formacion, setFormacion] = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);

  // Form inscripción
  const [form,      setForm]      = useState({ nombre:'', email:'', perfil:'profesional' });
  const [enviando,  setEnviando]  = useState(false);
  const [inscritoOk,setInscritoOk]= useState(false);
  const [acceso,    setAcceso]    = useState(null); // { video_url, archivo_url, link_externo }
  const [formError, setFormError] = useState('');

  /* Fetch formación */
  useEffect(() => {
    fetch(`${API}?action=detalle&slug=${slug}`)
      .then(r => r.json())
      .then(j => {
        if (j.success) setFormacion(j.data);
        else setError('Formación no encontrada');
      })
      .catch(() => setError('Error al cargar'))
      .finally(() => setLoading(false));
  }, [slug]);

  /* Pre-llenar si está logueado */
  useEffect(() => {
    if (estaLogueado && usuario) {
      setForm(f => ({
        ...f,
        nombre: usuario.nombre + (usuario.apellido ? ' ' + usuario.apellido : ''),
        email:  usuario.email,
        perfil: usuario.perfil || 'profesional',
      }));
    }
  }, [estaLogueado, usuario]);

  const handleInscribir = async e => {
    e.preventDefault();
    setFormError('');
    if (!form.nombre.trim()) { setFormError('Ingresa tu nombre'); return; }
    if (!form.email.includes('@')) { setFormError('Email no válido'); return; }
    setEnviando(true);
    try {
      const r = await fetch(`${API_INS}?action=inscribir`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre:       form.nombre,
          email:        form.email.toLowerCase(),
          perfil:       form.perfil,
          slug,
          fuente:       'pagina_formacion',
          utm_source:   new URLSearchParams(window.location.search).get('utm_source') || 'directo',
          utm_campaign: formacion?.utm_campaign || slug,
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setInscritoOk(true);
      setAcceso(j.data?.formacion || null);
    } catch(err) {
      setFormError(err.message || 'Error al procesar. Intenta de nuevo.');
    } finally {
      setEnviando(false);
    }
  };

  if (loading) return (
    <div className="fgd-loading">
      <div className="fgd-loading__spinner"/>
      <p>Cargando formación…</p>
    </div>
  );

  if (error || !formacion) return (
    <div className="fgd-error">
      <h2>Formación no encontrada</h2>
      <Link to="/formaciones" className="fgd-btn-back">← Volver a formaciones</Link>
    </div>
  );

  const accesoUrl = formacion.video_url || formacion.archivo_url || formacion.link_externo;

  return (
    <div className="fgd-page">

      {/* NAV */}
      <nav className="nav">
        <Link to="/" className="nav__logo">
          <span className="nav__logo-mark"/>Comunicar
        </Link>
        <div className="nav__links">
          <Link to="/formaciones" className="nav__active">Formaciones</Link>
          <Link to="/recursos">Recursos</Link>
          <Link to="/comunidad">Comunidad</Link>
          <Link to="/articulos">Artículos</Link>

          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>
      </nav>

      <div className="fgd-inner">

        {/* ── COLUMNA IZQUIERDA ── */}
        <div className="fgd-main">

          {/* Breadcrumb */}
          <div className="fgd-breadcrumb">
            <Link to="/formaciones">Formaciones</Link>
            <span>›</span>
            <span>Formaciones gratuitas</span>
            <span>›</span>
            <span>{formacion.titulo}</span>
          </div>

          {/* Badge + título */}
          <div className="fgd-head">
            <div className="fgd-head__badges">
              <span className="fgd-badge fgd-badge--free">Gratis</span>
              <span className="fgd-badge fgd-badge--tipo">{TIPO_LABEL[formacion.tipo] || formacion.tipo}</span>
              {formacion.categoria && <span className="fgd-badge fgd-badge--cat">{formacion.categoria}</span>}
            </div>
            <h1>{formacion.titulo}</h1>
            {formacion.descripcion && <p className="fgd-desc">{formacion.descripcion}</p>}
          </div>

          {/* Meta */}
          <div className="fgd-meta">
            {formacion.duracion   && <span><IconClock/> {formacion.duracion}</span>}
            {formacion.instructor && <span><IconUser/> {formacion.instructor}</span>}
            {formacion.nivel !== 'todos' && <span>📊 Nivel {formacion.nivel}</span>}
            <span><IconUsers/> {formacion.total_inscritos || 0} inscritos</span>
          </div>

          {/* Descripción larga */}
          {formacion.descripcion_larga && (
            <div className="fgd-desc-larga">
              <h2>Acerca de esta formación</h2>
              <p>{formacion.descripcion_larga}</p>
            </div>
          )}

          {/* Temario */}
          {formacion.temario && formacion.temario.length > 0 && (
            <div className="fgd-temario">
              <h2>Lo que aprenderás</h2>
              <ul>
                {formacion.temario.map((t,i) => (
                  <li key={i}><IconCheck/><span>{t}</span></li>
                ))}
              </ul>
            </div>
          )}

          {/* Video preview (si tiene) */}
          {formacion.video_url && (inscritoOk || estaLogueado) && (
            <div className="fgd-video">
              <h2>Ver formación</h2>
              {formacion.video_url.includes('youtube') || formacion.video_url.includes('youtu.be') ? (
                <div className="fgd-iframe-wrap">
                  <iframe
                    src={formacion.video_url.replace('watch?v=','embed/').replace('youtu.be/','www.youtube.com/embed/')}
                    title={formacion.titulo}
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
              ) : (
                <a href={formacion.video_url} target="_blank" rel="noopener noreferrer" className="fgd-video-link">
                  <IconPlay/> Ver video <IconExt/>
                </a>
              )}
            </div>
          )}

        </div>

        {/* ── COLUMNA DERECHA — PANEL INSCRIPCIÓN ── */}
        <div className="fgd-sidebar">
          <div className="fgd-panel">

            {/* Si ya está logueado Y ya se inscribió (o accede directo) */}
            {inscritoOk ? (
              <div className="fgd-panel__exito">
                <div className="fgd-panel__exito-icon">
                  <svg viewBox="0 0 24 24" fill="none" width="36" height="36">
                    <circle cx="12" cy="12" r="10" fill="#d4f4e8"/>
                    <path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>¡Estás inscrita!</h3>
                <p>Revisa tu correo — te enviamos los detalles y el acceso.</p>
                {acceso?.video_url && (
                  <a href={acceso.video_url} target="_blank" rel="noopener noreferrer" className="fgd-panel__btn">
                    <IconPlay/> Ver formación ahora
                  </a>
                )}
                {acceso?.archivo_url && (
                  <a href={acceso.archivo_url} target="_blank" rel="noopener noreferrer" className="fgd-panel__btn">
                    Descargar material
                  </a>
                )}
                {acceso?.link_externo && (
                  <a href={acceso.link_externo} target="_blank" rel="noopener noreferrer" className="fgd-panel__btn">
                    Acceder <IconExt/>
                  </a>
                )}
              </div>

            ) : estaLogueado ? (
              /* Logueado — inscripción con 1 clic */
              <div className="fgd-panel__logueado">
                <div className="fgd-panel__avatar">
                  {(usuario.nombre||'U')[0].toUpperCase()}
                </div>
                <h3>¡Hola, {usuario.nombre}!</h3>
                <p>Inscríbete con un clic para acceder a esta formación gratuita.</p>
                {formError && <div className="fgd-panel__error">{formError}</div>}
                <button className="fgd-panel__btn" onClick={handleInscribir} disabled={enviando}>
                  {enviando ? <><IconSpinner/> Procesando…</> : 'Inscribirme gratis →'}
                </button>
                <p className="fgd-panel__legal">
                  <IconCheck/> Sin costo · Recibirás acceso por email
                </p>
              </div>

            ) : (
              /* No logueado — formulario */
              <>
                <div className="fgd-panel__head">
                  <span className="fgd-panel__gratis">Completamente gratis</span>
                  <h3>Accede a esta formación</h3>
                  <p>Regístrate con tu nombre y correo para recibir el acceso.</p>
                </div>
                {formError && <div className="fgd-panel__error">{formError}</div>}
                <form className="fgd-panel__form" onSubmit={handleInscribir}>
                  <div className="fgd-panel__field">
                    <label>Tu nombre</label>
                    <div className="fgd-panel__input-wrap">
                      <span><IconUser/></span>
                      <input type="text" placeholder="Ej: Ana García"
                        value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} required/>
                    </div>
                  </div>
                  <div className="fgd-panel__field">
                    <label>Correo electrónico</label>
                    <div className="fgd-panel__input-wrap">
                      <span><IconMail/></span>
                      <input type="email" placeholder="tu@correo.com"
                        value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} required/>
                    </div>
                  </div>
                  <div className="fgd-panel__field">
                    <label>Soy…</label>
                    <div className="fgd-panel__perfiles">
                      {PERFIL_OPTS.map(({val,label})=>(
                        <button key={val} type="button"
                          className={`fgd-perfil-tab ${form.perfil===val?'fgd-perfil-tab--active':''}`}
                          onClick={()=>setForm(f=>({...f,perfil:val}))}
                        >{label}</button>
                      ))}
                    </div>
                  </div>
                  <button type="submit" className="fgd-panel__btn" disabled={enviando}>
                    {enviando ? <><IconSpinner/> Procesando…</> : 'Acceder gratis →'}
                  </button>
                  <p className="fgd-panel__legal">
                    <IconCheck/> Sin spam · Sin costo
                  </p>
                </form>
                <div className="fgd-panel__login-hint">
                  ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
                </div>
              </>
            )}

            {/* Acceso directo si ya tiene link y no requiere form */}
            {!inscritoOk && accesoUrl && (estaLogueado || inscritoOk) && (
              <a href={accesoUrl} target="_blank" rel="noopener noreferrer" className="fgd-panel__btn-secondary">
                Acceder directamente <IconExt/>
              </a>
            )}
          </div>

          {/* Card info */}
          <div className="fgd-info-card">
            <h4>Esta formación incluye:</h4>
            <ul>
              {formacion.video_url    && <li><IconCheck/> Video formativo</li>}
              {formacion.archivo_url  && <li><IconCheck/> Material descargable</li>}
              {formacion.link_externo && <li><IconCheck/> Acceso externo</li>}
              {formacion.temario?.length > 0 && <li><IconCheck/> {formacion.temario.length} módulos / temas</li>}
              <li><IconCheck/> Acceso inmediato por email</li>
              <li><IconCheck/> Sin costo</li>
            </ul>
          </div>
        </div>
      </div>

      {/* FOOTER mínimo */}
      <footer className="footer">
        <div className="footer__bottom" style={{maxWidth:'1200px',margin:'0 auto',padding:'1.5rem 5%',borderTop:'1px solid rgba(255,255,255,.06)',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:'1rem'}}>
          <p style={{fontSize:'.78rem',color:'rgba(255,255,255,.2)'}}>© 2025 Comunicar – Desarrollo y Lenguaje.</p>
          <Link to="/formaciones" style={{fontSize:'.78rem',color:'rgba(255,255,255,.35)'}}>← Volver a formaciones</Link>
        </div>
      </footer>
    </div>
  );
}